export default import.meta.ROLLDOWN_FILE_URL_31WQMuAHGQn67ooKheJ_4g